module.exports = __webpack_public_path__ + "porch-bg-selector.bab334e4.png";